import { isValidPhoneNumber } from 'react-phone-number-input';
import PresenceValidator from './PresenceValidator';

export default class PhoneNumberValidator {
  static isValid(value) {
    if (!PresenceValidator.isValid(value)) {
      return true;
    } else {
      return isValidPhoneNumber(value);
    }
  }
}
